import React, { useMemo, useState, useEffect } from "react"
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import Label from "components/general/Label";
import Noc from "components/presentation/Noc";
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';

const getConfiguration = (breakPoint, globalProps, eventorder) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };

  configuration.sortBy = [{ id: 'Competitor', desc: false }];

  configuration.columns = TableColumns(globalProps, configuration.disableSort)

  return configuration;
};


const TeamsTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const globalProps = useSelector(getGlobalProps)
  const config = useMemo(() => getConfiguration(breakPoint, globalProps), [breakPoint]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')

  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters()
  let paramsURL = { ...params }

  return (

    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='eventUnit-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-teams`}
      showPagination={true}
      pageSizeCustom={10}
    />


  )
}

export default TeamsTable;



function TableColumns(globalProps, disableSort) {
  return (
    [
      ColumnCompetitor(),
      ColumnNoc(),
      ColumnDiscipline(),
      ColumnEvent()
    ]
  )
}


export function ColumnDiscipline() {
  return (
    {
      Header: <Label data="HeaderDiscipline" />,
      className: 'schedule-discipline text-start',
      accessor: 'discipline.description',
      headerClassName: 'text-start w-30',
      disableSortBy: false,
      id: 'Discipline',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <Discipline code={row?.discipline?.code} description={row?.discipline?.description} />
        )
      }
    }
  )
}

export function ColumnNoc() {
  const competition = CompetitionFromStore();

  return (
    {
      Header: <Label data={isParalympic(competition) ? 'HeaderNPC' : 'HeaderNOC'} />,
      id: 'NOC',
      className: 'text-start',
      headerClassName: 'text-start w-20',
      accessor: 'organisation.longDescription',
      disableSortBy: false,
      Cell: (props) => {
        let data = props.cell.row.original?.organisation
        return (<Noc {...data} showLongDesc={true} />)
      }
    }
  )

}

export function ColumnCompetitor() {
  return (
    {
      Header: <Label data="LabelName" />,
      id: 'Competitor',
      className: 'schedule-discipline text-start',
      headerClassName: 'text-start',
      accessor: 'name',
      disableSortBy: false,
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <div className='text-wrap'><Competitor noLink={true} {...row} hideNoc={true} hidePicture={true} key={`participant-${row?.code}`} breakCouples={true}/></div>
        )
      }
    }
  )
}

export function ColumnEvent() {
  return (
    {
      Header: <Label data="LabelEvent" />,
      id: 'Event',
      className: 'schedule-discipline text-start',
      headerClassName: 'text-start',
      disableSortBy: false,
      accessor: 'registeredEvents.event.description',
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <>
            {row?.registeredEvents?.map((e) => {
              return (
                <div className='text-wrap' key={e?.code}>{e?.event?.longDescription}</div>
              )
            })}
          </>
        )
      }
    }
  )
}
